import { Button } from 'src/v2/commonComponents/Button';
import { Waveform } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useEffect, useState } from 'react';
import { useDownloadFileTool, useEditorState, useGetUser } from 'src/hooks';
import { ArtifactType, ConversionTargetType } from 'src/types';
import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';
import { toast } from 'react-toastify';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertToMarkdownString } from '@lexical/markdown';
import { TRANSFORMERS_LIST } from '../../constants/transformers';

export const DownloadEditorPodcastButton = () => {
  const [editor] = useLexicalComposerContext();
  const { editorType } = useEditorState();
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    if (editorType !== ArtifactType.TEXT) {
      setMarkdown('');
      return;
    }

    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const md = $convertToMarkdownString(TRANSFORMERS_LIST);
        setMarkdown(md);
      });
    });
  }, [editor, editorType]);

  const [isGenerating, setIsGenerating] = useState<boolean>(false);

  const { isOpenTier } = useGetUser();

  const { onDownload } = useDownloadFileTool({
    downloadToolType: 'editor',
  });

  const handleSuccess = () => {
    setIsGenerating(false);
    toast.success('Podcast downloaded to your device');
  };

  const handleClick = async () => {
    await onDownload({
      fileType: ConversionTargetType.PODCAST,
      onStart: () => setIsGenerating(true),
      onSuccess: handleSuccess,
      onFail: () => setIsGenerating(false),
    });
  };

  if (editorType !== ArtifactType.TEXT) {
    return null;
  }

  return (
    <Button
      shape="round"
      id="download-podcast-button"
      color="transparent"
      tooltipContent={
        !isGenerating
          ? 'Generate and download podcast as an .mp3 file'
          : undefined
      }
      tooltipPlace="bottom-start"
      onClick={handleClick}
      disabled={isOpenTier || isGenerating || !markdown.length}
    >
      {!isGenerating ? (
        <Waveform size={SVG_SIZE_M} />
      ) : (
        <SpinnerSimple size={SVG_SIZE_M} />
      )}
    </Button>
  );
};
